import React from "react";
import { NoticeBoldText, NoticeTextArea, NotiveSubText } from "./NoticeTextStyle";
import ImgNotice from "../../../resources/images/nftf/IconNotiveGray.svg";
import { IC } from "../../../resources/Assets";

const CommonNoticeText = props => {
  return (
    <NoticeTextArea>
      <div style={{ display: "flex", gap: "4px" }}>
        {props.psIcon && (
          <img
            src={IC.notice.ICON_NOTICE_PURPLE}
            style={{ alignSelf: "flex-start", transform: "rotate(180deg)" }}
          />
        )}

        <NoticeBoldText>{props.title}</NoticeBoldText>
        <NotiveSubText>{props.text}</NotiveSubText>
      </div>
    </NoticeTextArea>
  );
};

export default CommonNoticeText;
